import React from 'react';

import Icon from 'kingpin/atoms/Icon';

import { HeaderContent } from './DataTable.styles';

// The header for columns without a headerComponent: the label and, while
// sorted, which way. Clicking sorts (the <th> owns that).
const DefaultHeader = ({
  label,
  sort,
  isRightAligned,
  isCentered,
}: {
  label: string;
  sort: 'asc' | 'desc' | false;
  isRightAligned: boolean;
  // Column group labels sit over the middle of their columns
  isCentered?: boolean;
}) => (
  <HeaderContent isRightAligned={isRightAligned} isCentered={!!isCentered}>
    <span>{label}</span>
    {sort && (
      // The header's aria-sort says which way; the arrow is for the eye
      <span aria-hidden style={{ display: 'flex' }}>
        <Icon
          icon={sort === 'asc' ? 'arrow-up' : 'arrow-down'}
          width={10}
          height={10}
          color="var(--color-grid-header-text)"
        />
      </span>
    )}
  </HeaderContent>
);

export default DefaultHeader;
